import styled from 'styled-components';
import { MediaQuery, Size } from '../../constant/breakpoint.ts';

export const ArticleWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '80%',
  marginBottom: '80px',
  marginLeft: 'auto',
  marginRight: 'auto',
  rowGap: '40px',
  backgroundColor: '#F6F6F6',
  borderRadius: '30px',
  padding: "32px 64px 32px 64px",
  zIndex: '1',
  marginTop: '-200px',
  position: 'relative',
  
  [MediaQuery[Size.LG]]: {
    padding: "24px 48px 24px 48px",
    width: '90%',
    rowGap: '24px',
  },

  [MediaQuery[Size.MD]]: {
    padding: "16px 32px 16px 32px",
    width: '95%',
    rowGap: '16px',
  },
});

export const Section = styled('div')({
  padding: "64px 32px 64px 32px",
  display: "flex",
  justifyContent: "center",
  alignItems: 'center',
  position: "relative",
  width: 'auto',
  [MediaQuery[Size.LG]]: {
    padding: "64px 0px 64px 0px",
  },
  zIndex: '0',
  position: 'relative',
})


export const ArticleTitle = styled('div')({
    fontSize: '48px',
    fontWeight: '600',
    color: '#A0865B'
});

export const ArticleAuthor = styled('div')({
    fontSize: '24px',
    fontWeight: '500',
    color: '#676767'
});

export const ArticleDate = styled('div')({
    fontSize: '16px',
    fontWeight: '500',
    color: '#ffffff',
    borderRadius: '45px',
    backgroundColor: '#CCA25E',
    width: '156px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

export const ImageWrapper = styled('div')({
  display: "flex",
  justifyContent: "center",
  zIndex: 0,
  width: "100%",
  height: 'auto'
})

export const ImageCSS = styled('img')({
    width: 'auto',
    height: 'auto',
    borderRadius: '45px',
  
    objectFit: 'cover',
    [MediaQuery[Size.IMAGE_HEADER_SIZE]]: {
      width: '100%',
      height: '100vh',
      objectFit: 'cover',
    },
  })